import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import AuthNavbar from "../authNavigation/AuthNavbar";
import { useSelector } from "react-redux";

const Header = ({isReferral}) => {
  const { user } = useSelector((state) => state.customReducer);
  const [profileRenderKey, setProfileRenderKey] = useState(
    Number(sessionStorage.getItem("ProfileRenderKey")),
  );
  const token = `${
    sessionStorage.getItem("subscriberToken")
      ? sessionStorage.getItem("subscriberToken")
      : sessionStorage.getItem("token")
  }`;
  useEffect(() => {
    const handleStorageChange = () => {
      const newKey = Number(sessionStorage.getItem("ProfileRenderKey"));
      setProfileRenderKey(newKey);
    };

    // Add event listener for storage changes
    window.addEventListener("storage", handleStorageChange);

    // Clean up event listener on unmount
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const newKey = Number(sessionStorage.getItem("ProfileRenderKey"));
      if (newKey !== profileRenderKey) {
        setProfileRenderKey(newKey);
      }
    }, 1000); // Check every second

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, [profileRenderKey]);

  return (
    <div>
      {user.email && user.mobile && token && token !== "null" ? (
        <AuthNavbar key={profileRenderKey} />
      ) : (
        <Navbar isReferral={isReferral} />
      )}
    </div>
  );
};

export default Header;
